import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';
import { Alert, Card, Row, Col } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import ListaEquipamentos from './components/ListaEquipamentos/ListaEquipamentos';
import Map from './components/Map/Map';
import Reload from '../../components/reload/reload';
import Page from '../../components/Page/Page';
import Api from '../../services/Api';
import ApiMServer from '../../services/ApiMServer';
import ApiGServer from '../../services/ApiGServer';
import ApiGSenha from '../../services/ApiGSenha';
import dateformat from 'dateformat';
import DashMedidas from '../DashMedidas/DashMedidas';
import 'moment/locale/pt-br';

import AlertModal from '../../components/AlertModal/AlertModal'
import WelcomeModal from '../../components/WelcomeModal/WelcomeModal';

import { useWebSocket } from '../../hooks/webSocketContext';
import { checkAuth } from '../../hooks/actions/sessionActions';
import { UserContext } from '../../hooks/UserProvider';
import { getActiveTrialInfo } from '../../utilis/sguTrial';

import decodeJwt from '../../hooks/decode';
import { track } from '../../analytics';

import './Home.css';
import '../DashMedidas/DashMedidas.css';
import '../../styles/SguUnitsPage.css';

const Home = () => {

  const socket = useWebSocket();
  const location = useLocation();
  const session = checkAuth();
  const isJoinedRef = useRef(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (session === false) {
      navigate("/logout");
    }
  }, [session, navigate]);

  const [selectedEquipment] = useState(null);
  const [equipmentsStatus, setEquipmentsStatus] = useState([]);
  const [allPoints, setAllPoints] = useState([]);
  const [points, setPoints] = useState([]);
  const [units, setUnits] = useState([]);
  const [companyNames, setCompanyNames] = useState([]);
  const [grains, setGrains] = useState([]);
  const [stateNames, setStateNames] = useState([]);
  const [typeEquipaments, setTypeEquipaments] = useState([]);
  const [measurementReceived, setMeasurementReceived] = useState('');
  const [lastMedida, setLastMedida] = useState({});
  const [messageReceived, setMessageReceived] = useState([]);
  const [liveRotationStatuses, setLiveRotationStatuses] = useState({});
  const [lastMeasurementsMap, setLastMeasurementsMap] = useState(() => {
    try {
      const stored = sessionStorage.getItem('lastMeasurementsMap');
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  });
  const [loading, setLoading] = useState(true);
  const [handlePage, setHandlePage] = useState("map");
  const [isHistoricMode, setIsHistoricMode] = useState(false);
  const [currentPeriod, setCurrentPeriod] = useState('month');
  const [showModal, setShowModal] = useState(false);
  const [msg, setMsg] = useState({ title: "", message: "" });
  const [serialnumber, setSerialnumber] = useState("");
  const [serialnumberCompany, setSerialnumberCompany] = useState("");
  const [localEquipamentSelecionado, setLocalEquipamentSelecionado] = useState(null);
  const [retryAction, setRetryAction] = useState(null);

  const [cooperative, setCooperative] = useState(() => {
    try {
      const stored = localStorage.getItem('cooperative');
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      console.error('Erro ao ler cooperative do localStorage:', error?.message);
      return null;
    }
  });

  const [availablePeriods, setAvailablePeriods] = useState({
    month: false,
    year: false,
    all: true
  });

  const [user,] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const { user: contextUser } = useContext(UserContext) || {};
  const effectiveUser = contextUser || user;
  const trialInfo = useMemo(
    () => getActiveTrialInfo(effectiveUser),
    [effectiveUser]
  );

  const trialDismissStorageKey = 'sguTrialAlertDismissed';

  const isTrialAlertDismissed = (trialEndValue) => {
    if (!trialEndValue) return false;
    try {
      return localStorage.getItem(trialDismissStorageKey) === String(trialEndValue);
    } catch {
      return false;
    }
  };

  const [showTrialAlert, setShowTrialAlert] = useState(() =>
    !isTrialAlertDismissed(effectiveUser?.sguTrial)
  );

  useEffect(() => {
    setShowTrialAlert(!isTrialAlertDismissed(effectiveUser?.sguTrial));
  }, [effectiveUser?.sguTrial]);

  const handleDismissTrialAlert = () => {
    setShowTrialAlert(false);
    try {
      if (effectiveUser?.sguTrial) {
        localStorage.setItem(trialDismissStorageKey, String(effectiveUser.sguTrial));
      }
    } catch {
      /* ignore */
    }
  };

  const userDecoded = decodeJwt();
  const { permissionSGU } = userDecoded;

  const handleShow = () => setShowModal(true);
  const handleClose = () => {
    setShowModal(false);
    setRetryAction(null);
  };
  const handleRetry = () => {
    const action = retryAction;
    handleClose();
    if (action) {
      setLoading(true);
      action();
    }
  };

  const reloadEmpresas = async () => {
    const units = JSON.parse(localStorage.getItem('units')) || [JSON.parse(localStorage.getItem('cooperative'))] || [];
    return [...units];
  };

  const setSelectedEquipment = async (data) => {
    const empresasAtualizadas = await reloadEmpresas();
    const empresaEncontrada = empresasAtualizadas.find(empresa =>
      empresa?.equipments?.includes(data?.serial)
    );

    setSerialnumber(data?.serial);
    if (empresaEncontrada?._id) {
      setSerialnumberCompany(empresaEncontrada._id);
    }
    const localEncontrado = empresaEncontrada?.localEquipament?.find((item) => item.serial === data?.serial);
    setLocalEquipamentSelecionado(localEncontrado || null);
    handlePageMap("graphic");

    if (data?.serial) {
      track("equipment_viewed", {
        equipmentId: data.serial,
        unitId: empresaEncontrada?._id || null,
      });
    }
  };


  const fetchData = async () => {
    try {
      let currentCooperative = cooperative;
      if (currentCooperative) {
        const updated = await handleCompany();
        if (updated) currentCooperative = updated;
      }

      if (currentCooperative?.units?.length) {
        await getCooperative(currentCooperative);
      } else {
        await getUnit();
      }
    } catch (error) {
      console.error("Error fetchData data:", error?.message || error);
    }
  };


  const isHistoricModeRef = useRef(isHistoricMode);
  useEffect(() => {
    isHistoricModeRef.current = isHistoricMode;
  }, [isHistoricMode]);

  useEffect(() => {
    fetchData();
    const intervalId = setInterval(() => {
      if (!isHistoricModeRef.current) {
        getConnection();
      }
    }, 30000);
    return () => clearInterval(intervalId);
  }, []);


  const setHistoricEquipment = async (value, period = null) => {
    if (value) {
      setIsHistoricMode(true);
      // Ativa o loader antes de começar as requisições
      setLoading(true);
    } else {
      setIsHistoricMode(false);
      setAllPoints([...points]);
      return;
    }

    try {
      // Reiniciar o estado dos períodos disponíveis
      const periodAvailability = {
        month: false,
        year: false,
        all: false
      };

      let data = [];
      let usedPeriod = period;

      // Se o período for especificado, busca diretamente pelo período solicitado
      if (period) {
        const response = await ApiGSenha.get(`/api/v1/unblock?serial=${value}&type=${period}`);
        data = response.data;
        if (data && data.length > 0) {
          periodAvailability[period] = true;
        } else {
          setLoading(false);
          setIsHistoricMode(false);
          setMsg({
            title: "Sem dados",
            message: `Nenhum dado encontrado para o período ${period}.`
          });
          handleShow();
          return;
        }
      } else {
        // Se o período não for especificado, tenta encontrar qual período tem dados
        // Tentar buscar dados mensais
        let response = await ApiGSenha.get(`/api/v1/unblock?serial=${value}&type=month`);
        data = response.data;
        usedPeriod = 'month';

        if (data && data.length > 0) {
          periodAvailability.month = true;
        } else {
          // Se não tiver dados mensais, tenta anual
          usedPeriod = 'year';
          response = await ApiGSenha.get(`/api/v1/unblock?serial=${value}&type=year`);
          data = response.data;

          if (data && data.length > 0) {
            periodAvailability.year = true;
          } else {
            // Se não tiver dados anuais, tenta todos
            usedPeriod = 'all';
            response = await ApiGSenha.get(`/api/v1/unblock?serial=${value}&type=all`);
            data = response.data;

            if (data && data.length > 0) {
              periodAvailability.all = true;
            } else {
              // Desativa o loader quando não há dados disponíveis
              setLoading(false);
              setIsHistoricMode(false);
              setMsg({
                title: "Sem dados",
                message: `Histórico não encontrado para o equipamento ${value}`
              });
              handleShow();
              return;
            }
          }
        }
      }

      // Atualizar o estado do período atual com o período realmente usado
      setCurrentPeriod(usedPeriod);

      // Verificar disponibilidade dos outros períodos se ainda não foram verificados
      if (!periodAvailability.month && usedPeriod !== 'month') {
        try {
          const monthResponse = await ApiGSenha.get(`/api/v1/unblock?serial=${value}&type=month`);
          periodAvailability.month = monthResponse.data && monthResponse.data.length > 0;
        } catch (error) {
          console.warn('Erro ao verificar dados mensais:', error);
        }
      }

      if (!periodAvailability.year && usedPeriod !== 'year') {
        try {
          const yearResponse = await ApiGSenha.get(`/api/v1/unblock?serial=${value}&type=year`);
          periodAvailability.year = yearResponse.data && yearResponse.data.length > 0;
        } catch (error) {
          console.warn('Erro ao verificar dados anuais:', error);
        }
      }

      if (!periodAvailability.all && usedPeriod !== 'all') {
        try {
          const allResponse = await ApiGSenha.get(`/api/v1/unblock?serial=${value}&type=all`);
          periodAvailability.all = allResponse.data && allResponse.data.length > 0;
        } catch (error) {
          console.warn('Erro ao verificar todos os dados:', error);
        }
      }

      // Atualizar o estado com os períodos disponíveis
      setAvailablePeriods(periodAvailability);

      if (!data || !Array.isArray(data)) {
        console.warn('Dados recebidos não são um array válido');
        // Desativa o loader se os dados não são válidos
        setLoading(false);
        return;
      }

      const pins = data
        .map((equipment) => {
          const lat = Number(parseFloat(equipment.lat || 0).toFixed(8));
          const lng = Number(parseFloat(equipment.lng || 0).toFixed(8));

          // Validação de coordenadas
          if (lat === 0 || lng === 0 || isNaN(lat) || isNaN(lng)) {
            return null;
          }

          // Desestruturação com valores padrão para tornar o código mais limpo
          const {
            updatedAt,
            nameEquipament = '',
            email = '',
            serialnumber = '',
            cupid = '',
            daystoactivate = '0',
            dcal = '',
            equipid = '',
            isentkey = '',
            mode = '',
            mscal = '',
            wf = '',
            sha1curva = '',
            versaosw = '',
            versaofwpri = '',
            versaofwosc = '',
            address = '',
            createdAt = '',
            name = '',
          } = equipment;

          return {
            serial: serialnumber,
            lat,
            lng,
            nameEquipament,
            email,
            date: dateformat(updatedAt) || '',
            address,
            versaosw,
            versaofwpri,
            versaofwosc,
            cupid,
            daystoactivate: parseInt(daystoactivate, 16) || 0,
            dcal,
            equipid,
            isentkey,
            mode,
            mscal,
            wf,
            sha1curva,
            createdAt,
            name
          };
        })
        .filter(Boolean); // Remove itens nulos (coordenadas inválidas)

      // Ordenar os pins pelo createdAt
      pins.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return dateA - dateB; // Ordem crescente (do mais antigo para o mais recente)
      });

      const points = pins.map((item, index) => ({
        properties: {
          id: `${item.serial} - ${index}`,
          data: item,
          cluster: false,
        },
        geometry: {
          type: "Point",
          coordinates: [item.lng, item.lat] // Não precisamos do parseFloat pois já convertemos antes
        }
      }));

      setAllPoints(points);

      // Desativa o loader após o processamento completo
      setLoading(false);
    } catch (error) {
      console.error('Erro ao buscar histórico de equipamentos:', error);
      setAllPoints([]);
      // Garante que o loader seja desativado em caso de erro
      setLoading(false);
      // Notifica o usuário sobre o erro
      setMsg({
        title: "Erro ao carregar histórico",
        message: "Ocorreu um erro ao carregar o histórico do equipamento. Por favor, tente novamente."
      });
      handleShow();
    }
  };

  const handlePageMap = (item) => {
    setHandlePage(item);
  }

  const getCooperative = async (cooperativeParam = cooperative) => {
    try {
      let { data } = await ApiMServer.post('/company/get/units', { arrayIds: cooperativeParam?.units || [] });
      if (cooperativeParam?.equipments?.length) {
        data.push(cooperativeParam);
      }

      setUnits(data);
      localStorage.setItem('units', JSON.stringify(data));

      const allEquipments = Array.isArray(data)
        ? data.flatMap(item =>
          Array.isArray(item?.equipments) ? item.equipments : []
        )
        : [];
      localStorage.setItem('equipment', JSON.stringify(allEquipments));

      const otherEquipments = Array.isArray(data)
        ? data.flatMap(item => item?.otherEquipments ?? item ?? [])
        : [];
      localStorage.setItem('otherEquipments', JSON.stringify(otherEquipments));

      const companyNames = data.map(unit => unit.name).flat().sort();
      setCompanyNames(companyNames);

      if (!allEquipments.length) {
        setLoading(false);
        setMsg({
          title: "Nenhum equipamento",
          message: "A empresa carregada não possui equipamentos cadastrados."
        });
        handleShow();
        return;
      }

      handleEquipamentFilter(allEquipments);

    } catch (error) {
      console.error(error.message);
      setLoading(false);
      setMsg({
        title: "Erro ao carregar unidades",
        message: "Ocorreu um erro ao carregar as unidades."
      });
      handleShow();
    }
  };

  const getUnit = async () => {
    const cooperative = JSON.parse(localStorage.getItem('cooperative'));
    const userFromStorage = JSON.parse(localStorage.getItem('user')) || {};
    const hasAllowedUnitIds = Array.isArray(userFromStorage?.allowedUnitIds) && userFromStorage.allowedUnitIds.length > 0;

    const equipments = Array.isArray(cooperative?.equipments) ? cooperative.equipments : [];
    localStorage.setItem('equipment', JSON.stringify(equipments));

    if (!equipments.length) {
      setLoading(false);
      setMsg({
        title: "Nenhum equipamento",
        message: "A empresa carregada não possui equipamentos cadastrados."
      });
      handleShow();
    } else {
      handleEquipamentFilter(equipments);
    }

    // Em sessão multiunidade, preserva "units" para manter o seletor de unidade disponível.
    if (!hasAllowedUnitIds && localStorage.getItem('units')) {
      localStorage.removeItem('units');
    }
  };

  const handleEquipamentFilter = async (equipments) => {
    setRetryAction(null);
    setLoading(true);
    try {
      const { data } = await ApiGServer.post('/equipment/filter', { filter: equipments });
      if (data && data.length > 0) {
        loadMap(data);
      } else {
        setLoading(false);
        setMsg({
          title: "Nenhum equipamento",
          message: "Nenhum equipamento cadastrado."
        });
        setRetryAction(() => () => handleEquipamentFilter(equipments));
        handleShow();
      }
    } catch (error) {
      console.error("Erro ao carregar equipamentos:", error?.message);
      setLoading(false);
      setMsg({
        title: "Erro ao carregar equipamentos",
        message: "Ocorreu um erro ao carregar os equipamentos. Deseja tentar novamente?"
      });
      setRetryAction(() => () => handleEquipamentFilter(equipments));
      handleShow();
    }
  };

  const loadMap = async (response) => {
    const result = [];
    const state = [];

    if (response) {
      response.forEach((equipment) => {
        let lat = Number(parseFloat(equipment.lat).toFixed(8));
        let lng = Number(parseFloat(equipment.lng).toFixed(8));
        let date = dateformat(equipment.updatedAt) ?? '';
        let nameEquipament = equipment.nameEquipament ?? '';
        let email = equipment.email ?? '';
        let serial = equipment.serialnumber ?? '';
        let cupid = equipment.cupid ?? '';
        let daystoactivate = parseInt(equipment.daystoactivate, 16) ?? '';
        let dcal = equipment.dcal ?? '';
        let equipid = equipment.equipid ?? '';
        let isentkey = equipment.isentkey ?? '';
        let mode = equipment.mode ?? '';
        let mscal = equipment.mscal ?? '';
        let wf = equipment.wf ?? '';
        let sha1curva = equipment.sha1curva ?? '';
        let versaosw = equipment.versaosw ?? '';
        let versaofwpri = equipment.versaofwpri ?? '';
        let versaofwosc = equipment.versaofwosc ?? '';
        let address = equipment.address ?? '';

        if (lat === 0 || lng === 0) return;
        if (isNaN(lat) || isNaN(lng)) {
          return;
        }
        result.push({
          serial, lat, lng, nameEquipament, email, date, address, versaosw, versaofwpri, versaofwosc, cupid, daystoactivate, dcal, equipid, isentkey, mode, mscal, wf, sha1curva
        });
        state.push(address.state ?? '');
      });
    }

    const uniqueStateNames = [...new Set(state
      .map(({ shortname }) => shortname)
      .filter(shortname => shortname !== undefined && shortname !== "")
    )];

    setStateNames(uniqueStateNames);

    let points = result.map(item => ({
      properties: {
        id: item.serial,
        data: item,
        cluster: false
      },
      geometry: {
        type: "Point",
        coordinates: [
          parseFloat(item.lng),
          parseFloat(item.lat)
        ]
      }
    }));

    points = points.sort((a, b) => a.properties.data.serial - b.properties.data.serial);
    setAllPoints(points);
    setPoints(points);
    await getConnection(points);
    setLoading(false);
  }

  const getConnection = async () => {
    const serials = JSON.parse(localStorage.getItem('equipment'));

    if (serials && serials.length) {
      const uniquePrefixes = [...new Set(serials.map(serial => serial.substring(0, 4)))];
      setTypeEquipaments(uniquePrefixes);

      try {
        let { data } = await Api.post('/api/v1/lastbenchone', { equipments: serials });
        setEquipmentsStatus(data);

        if (data) {
          // Alimenta lastMeasurementsMap com medidas recentes do poll (dentro de 5 minutos)
          const FIVE_MIN_MS = 5 * 60 * 1000;
          const freshEntries = data.reduce((acc, item) => {
            const measureDate = item?.measurement?.date;
            if (item?.measurement?.humidity != null && measureDate) {
              const age = Date.now() - new Date(measureDate).getTime();
              if (age <= FIVE_MIN_MS) {
                acc[item.serialnumber] = {
                  ...item.measurement,
                  receivedAt: measureDate,
                };
              }
            }
            return acc;
          }, {});

          if (Object.keys(freshEntries).length > 0) {
            setLastMeasurementsMap(prev => {
              const updated = { ...prev, ...freshEntries };
              try {
                sessionStorage.setItem('lastMeasurementsMap', JSON.stringify(updated));
              } catch { /* sessionStorage cheio ou indisponível */ }
              return updated;
            });
          }
          const grains = [...new Set(data.filter(item => item?.measurement && item?.measurement?.grain).map(item => item.measurement.grain))];
          setGrains(grains);

          if (data.length) {
            const updateWithGrains = (prevPoints) => {
              if (prevPoints && prevPoints.length > 0) {
                return mergePointsWithGrains(prevPoints, data);
              }
              return prevPoints;
            };

            setPoints(updateWithGrains);
            setAllPoints(updateWithGrains);
          }
        } else {
          return
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  const mergePointsWithGrains = (points, grainsData) => {
    return points.map(point => {
      const grainData = grainsData.find(grain => grain.serialnumber === point.properties.id);

      return grainData
        ? { ...point, properties: { ...point.properties, grain: grainData?.measurement?.grain || "", unlockData: grainData?.unlockData } }
        : point;
    });
  };

  const handleCompany = async () => {
    try {
      const { data } = await ApiMServer.post('/company/detail', { id: cooperative._id });

      if (!data) {
        throw new Error("Dados da empresa inválidos.");
      }

      // Recupera dados antigos do localStorage
      const current = JSON.parse(localStorage.getItem('cooperative')) || {};

      // Mescla os dados antigos com os novos
      const updatedCompany = {
        ...current,
        ...data
      };

      // Salva atualizado e atualiza o estado
      localStorage.setItem('cooperative', JSON.stringify(updatedCompany));
      setCooperative(updatedCompany);

      return updatedCompany;

    } catch (error) {
      console.error("Erro ao carregar detalhes da empresa:", error);

      alert("Erro ao carregar detalhes da empresa. Tente novamente.");

      // Remove apenas a empresa em vez de limpar tudo
      localStorage.removeItem('cooperative');
      setCooperative(null);
      return null;
    }
  };

  const [searchValue, setSearchValue] = useState("");

  const handleSearchData = (value) => {
    // Armazena o valor da busca no localStorage
    localStorage.setItem("searchValue", value);
    setSearchValue(value);

    const result = points.filter(point => {
      const serial = point?.properties?.data?.serial?.toUpperCase();
      const nameEquipament = point?.properties?.data?.nameEquipament?.toUpperCase();
      const companyName = getCompanyName(serial)?.toUpperCase();

      return (
        serial?.includes(value.toUpperCase()) ||
        nameEquipament?.includes(value.toUpperCase()) ||
        companyName?.includes(value.toUpperCase())
      );
    });

    setAllPoints(result);
  };

  useEffect(() => {
    const passedSerial = location.state?.serial;
    const passedView = location.state?.view;

    if (passedSerial) {
      if (passedView === 'graphic') {
        setSelectedEquipment({ serial: passedSerial });
      }
      handleSearchData(passedSerial);
    } else {
      const savedSearch = localStorage.getItem("searchValue");
      if (savedSearch) {
        setSearchValue(savedSearch);
        handleSearchData(savedSearch);
      } else {
        setAllPoints(points);
      }
    }
  }, [points, location.state]);

  const [activeFilters, setActiveFilters] = useState({
    company: '',
    state: '',
    grain: '',
    typeEquipament: ''
  });

  const filter = async (company, state, grain, typeEquipament) => {
    // Atualizar filtros ativos
    setActiveFilters({
      company: company || '',
      state: state || '',
      grain: grain || '',
      typeEquipament: typeEquipament || ''
    });

    const result = points.filter((item) => {
      const isCompanyValid = company === '' || company === "Unidades" ||
        (units.find((unit) => unit.name === company)?.equipments.includes(item.properties.data.serial) ?? false);

      const isStateValid = state === '' || state === "Estados" ||
        item?.properties?.data?.address?.state?.shortname === state;

      const isGrainValid = grain === '' || grain === "Curvas" ||
        item?.properties?.grain === grain;

      const isEquipaments = typeEquipament === '' || typeEquipament === "Equipamentos" ||
        item?.properties?.id?.includes(typeEquipament);

      return isCompanyValid && isStateValid && isGrainValid && isEquipaments;
    });

    const nameCompany = result.map(item => getCompanyName(item?.properties?.data?.serial));
    const uniqueCompany = [...new Set(nameCompany)];

    if (uniqueCompany.length > 0 && !company) {
      setCompanyNames(uniqueCompany);
    }

    const uniqueStateNames = [...new Set(result
      .map((item) => item?.properties?.data?.address?.state?.shortname)
      .filter(shortname => shortname !== undefined && shortname !== "")
    )];

    if (uniqueStateNames.length > 0 && !state) {
      setStateNames(uniqueStateNames);
    }

    const uniqueGrains = [...new Set(result
      .map((item) => item?.properties?.grain)
      .filter(shortname => shortname !== undefined && shortname !== "")
    )];
    if (uniqueGrains.length > 0 && !grain) {
      setGrains(uniqueGrains);
    }

    const uniquePrefixes = [...new Set(result
      .map((item) => item?.properties?.data?.serial.substring(0, 4)))
    ];
    if (uniquePrefixes.length > 0 && !typeEquipament) {
      setTypeEquipaments(uniquePrefixes);
    }

    setAllPoints(result);
  };

  useEffect(() => {
    if (handlePage === "map" && activeFilters && points.length > 0) {
      filter(
        activeFilters.company,
        activeFilters.state,
        activeFilters.grain,
        activeFilters.typeEquipament
      );
    }
  }, [handlePage]);

  const getCompanyName = (serialnumber) => {
    const units = JSON.parse(localStorage.getItem('units')) || [JSON.parse(localStorage.getItem('cooperative'))] || [];
    const empresaEncontrada = units.find(unit => Array.isArray(unit.equipments) && unit.equipments.includes(serialnumber));
    return empresaEncontrada?.name || "";
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const serials = JSON.parse(localStorage.getItem("equipment")) || [];

      const units = JSON.parse(localStorage.getItem("units")) || [];
      const otherSerials = units.flatMap(unit =>
        Array.isArray(unit?.otherEquipments)
          ? unit.otherEquipments.map(e => e.serialNumber).filter(Boolean)
          : []
      );

      const cooperative = JSON.parse(localStorage.getItem("cooperative")) || [];

      const otherSerialsCooperative = cooperative?.otherEquipments
        .map(e => e.serialNumber)
        .filter(Boolean);

      const allSerials = [...new Set([...serials, ...otherSerials, ...otherSerialsCooperative])];

      if (!Array.isArray(allSerials) || allSerials.length === 0) {
        console.warn("Nenhum serial encontrado no localStorage.");
        return;
      }

      if (!user?.email) {
        console.error("Usuário não encontrado.");
        return;
      }

      if (!socket) {
        console.warn("WebSocket não foi inicializado.");
        return;
      }

      const alreadyJoined = sessionStorage.getItem("joinedRoom");

      const connectClient = () => {
        if (!alreadyJoined && !isJoinedRef.current) {
          socket.send(
            JSON.stringify({
              type: "join",
              room: allSerials,
              content: { name: `${user.email}-SGU` },
            })
          );

          isJoinedRef.current = true;
          sessionStorage.setItem("joinedRoom", "true");
        }

        socket.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);

            if (data?.medida?.type === 'status' && data?.medida?.serialnumber?.toUpperCase().includes('RODZ')) {
              setLiveRotationStatuses(prev => ({
                ...prev,
                [data.medida.serialnumber]: data.medida.rotationStatus,
              }));
            } else if (data?.medida?.serialnumber && allSerials.includes(data.medida.serialnumber)) {
              // Atualiza o mapa de últimas medidas para todos os equipamentos (usado no alarme do menu lateral)
              setLastMeasurementsMap(prev => {
                const updated = {
                  ...prev,
                  [data.medida.serialnumber]: { ...data.medida, receivedAt: new Date().toISOString() },
                };
                try {
                  sessionStorage.setItem('lastMeasurementsMap', JSON.stringify(updated));
                } catch { /* sessionStorage cheio ou indisponível */ }
                return updated;
              });
              // Atualiza a medida do equipamento selecionado no dashboard
              setMeasurementReceived(data.medida);
              // Atualiza a medida do equipamento selecionado no dashboard
              if (serialnumber === data.medida.serialnumber) {
                setLastMedida(data.medida);
              }
            } else if (data?.content?.message) {
              setMessageReceived((prevMessages) => ({
                ...prevMessages,
                [data.room]: data.content.message,
              }));
            }
          } catch (error) {
            console.error("Erro ao processar a mensagem:", error?.message);
          }
        };
      };

      if (socket.readyState === WebSocket.OPEN) {
        connectClient();
      } else {
        socket.onopen = () => {
          connectClient();
        };
      }
    }, 800);

    return () => {
      clearTimeout(timeoutId);
      if (socket) {
        socket.onopen = null;
        socket.onmessage = null;
      }
    };
  }, [socket, user]);

  const [highlightedSerials, setHighlightedSerials] = useState([]);
  const timerRef = useRef({});

  useEffect(() => {
    if (measurementReceived?.serialnumber) {
      setHighlightedSerials([measurementReceived.serialnumber]);

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(() => {
        setHighlightedSerials([]);
        timerRef.current = null;
      }, 5000);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [measurementReceived]);

  // Função para exportar todos os equipamentos em formato Excel
  const handleExportAllEquipments = async (allData) => {
    // Verificar se temos dados para exportar
    if (!allPoints || allPoints.length === 0) {
      setMsg({
        title: "Exportação de dados",
        message: "Não há dados disponíveis para exportar."
      });
      handleShow();
      return;
    }
    setLoading(true); // Mostrar tela de carregamento durante 

    const add_fields_list = [];
    const serial_list = [];

    try {
      // Primeiro loop: iniciar todas as requisições e armazenar promessas
      for (let index = 0; index < allPoints.length; index++) {
        const point = allPoints[index];
        const pointData = point.properties.data;
        const serial = pointData.serial;

        const companyName = getCompanyName(serial);

        serial_list.push(serial);

        add_fields_list.push({
          "serial": serial,
          "Nome do Equipamento": pointData.nameEquipament || 'N/D',
          'Dias para Ativar': pointData.daystoactivate || 'N/D',
          'Empresa': companyName || 'N/D',
        });
      }

      const filter = {
        "filter": {
          "list": serial_list,
          "request_data": {
            "serialnumber": true,
            "name": true,
            "email": true,
            "updatedAt": true,
            "address": true,
            "lat": true,
            "lng": true,
            "versaosw": true,
          },
          "add_fields": add_fields_list,
          "format_names": {
            "name": "Nome",
            "serialnumber": "Serial",
            "updatedAt": "Data",
            "address": "Endereço",
            "lat": "Latitude",
            "lng": "Longitude",
            "versaosw": "Versão Software",
            "email": "Email",
          },
          "all_data": allData,
          "excel": true
        }
      }

      ApiGSenha.post("/api/logs/unlockfilter", filter, {
        responseType: 'blob'
      })
        .then((response) => {
          // Cria um blob a partir da resposta
          const url = window.URL.createObjectURL(new Blob([response.data]));
          // Cria um link temporário
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'desbloqueios.xlsx'); // Nome do arquivo
          document.body.appendChild(link);
          link.click();
          // Remove o link após o download
          link.parentNode.removeChild(link);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Erro ao gerar relatório:", error);
          alert("Ocorreu um erro ao gerar o relatório. Por favor, tente novamente.");
        });
    } catch (error) {
      setLoading(false);
      console.error("Erro ao gerar relatório:", error);
      alert("Ocorreu um erro ao gerar o relatório. Por favor, tente novamente.");
    }

  };

  return (
    <Page title={"SGU - Sistema de Gestão de Unidades"}>

      {/* <Headers page={"SGU - Sistema de Gestão de Unidades"} /> */}

      {loading && <Reload />}

      <WelcomeModal />

      {trialInfo && showTrialAlert && user?.permissionSGU?.home?.read && (
        <Alert
          variant="warning"
          dismissible
          onClose={handleDismissTrialAlert}
          closeLabel="Fechar aviso de período de avaliação"
          className="mb-2 trial-alert"
        >
          <div className="trial-alert__content">
            <FaInfoCircle className="trial-alert__icon" aria-hidden />
            <span>{trialInfo.message}</span>
          </div>
        </Alert>
      )}

      {/* {lastMedida.serialnumber && handlePage !== "map" && <Notification lastMedida={lastMedida} />} */}

      {user?.permissionSGU?.home?.read ?
        <div className="dash-medidas-page dash-medidas-container home-page sgu-units-page">
          <div className="dash-medidas-stack">
            <Row className="dash-medidas-grid g-3 sgu-units-main-row">

          <AlertModal
            show={showModal}
            handleClose={handleClose}
            msg={msg}
            onRetry={retryAction ? handleRetry : undefined}
          />

          <Col
            xs={12}
            sm={12}
            md={4}
            lg={3}
            xl={3}
            xxl={3}
            className="sgu-units-col home-equip-col"
          >
            <ListaEquipamentos
              user={user}
              points={allPoints}
              handlePageMap={handlePageMap}
              handlePage={handlePage}
              setSelectedEquipment={setSelectedEquipment}
              setHistoricEquipment={setHistoricEquipment}
              isHistoricMode={isHistoricMode}
              equipmentsStatus={equipmentsStatus}
              handleSearchData={handleSearchData}
              clearEquipmentSearch={() => {
                localStorage.setItem("searchValue", "");
                setSearchValue("");
                filter(
                  activeFilters.company,
                  activeFilters.state,
                  activeFilters.grain,
                  activeFilters.typeEquipament
                );
              }}
              measurementReceived={measurementReceived}
              highlightedSerials={highlightedSerials}
              setHighlightedSerials={setHighlightedSerials}
              lastMedida={lastMedida}
              searchValue={searchValue}
              messageReceived={messageReceived}
              liveRotationStatuses={liveRotationStatuses}
              lastMeasurementsMap={lastMeasurementsMap}
            />
          </Col>

          {handlePage === "map" ?
            <>
              <Col xs={12} sm={12} md={8} lg={9} xl={9} xxl={9} className="flex-grow-1 home-map-col">
                <Map
                  user={user}
                  setSelectedEquipment={setSelectedEquipment}
                  setHistoricEquipment={setHistoricEquipment}
                  isHistoricMode={isHistoricMode}
                  selectedEquipment={selectedEquipment}
                  medida={measurementReceived}
                  highlightedSerials={highlightedSerials}
                  points={allPoints}
                  equipmentsStatus={equipmentsStatus}
                  filter={filter}
                  cooperative={cooperative}
                  companyNames={companyNames}
                  stateNames={stateNames}
                  typeEquipaments={typeEquipaments}
                  grains={grains}
                  activeFilters={activeFilters}
                  handleExportAllEquipments={handleExportAllEquipments}
                  availablePeriods={availablePeriods}
                  currentPeriod={currentPeriod}
                  handleSearchData={handleSearchData}
                />
              </Col>
            </>
            :
            <Col xs={12} sm={12} md={8} lg={9} xl={9} xxl={9} className='flex-grow-1'>
              {serialnumberCompany && serialnumber &&
                <DashMedidas
                  user={user}
                  setMsg={setMsg}
                  id={serialnumber}
                  handleShow={handleShow}
                  handlePageMap={handlePageMap}
                  empresaId={serialnumberCompany}
                  localEquipament={localEquipamentSelecionado}
                  permissionSGU={permissionSGU}
                />}
            </Col>
          }
            </Row>
          </div>
        </div>
        :

        <Card className='p-2'>
          <h2 className='text-center'>Você não tem permissão para acessar o sistema. <br /> Entre em contato com o administrador!</h2>
        </Card>
      }
    </Page>
  );
};
export default Home;
